import { FormContext } from '../../../../utils/context/contextFactory';
import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import {
  FormState,
  FormStatus,
} from '../../../../utils/state/initialStateFactory';
import { CalculatePaymentDetails } from '../calculatePaymentDetails/calculatePaymentDetails';

export type SetNumberOfParticipants = (numberOfParticipants: number) => void;

export function createSetNumberOfParticipantsAction(
  { getControllerState }: ActionFactoryParams<FormState, FormContext>,
  calculatePaymentDetailsAction: CalculatePaymentDetails,
): SetNumberOfParticipants {
  return async (numberOfParticipants: number) => {
    const [_, setState] = getControllerState();
    setState({
      numberOfParticipants,
      status: FormStatus.PROCESSING_PAYMENT_DETAILS,
    });

    calculatePaymentDetailsAction();
  };
}
